import { useContext, useMemo } from 'react';
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import Dropzone from 'react-dropzone';
import ToastContext from '../store/toast-context';

export const Upload = ({ onDrop = () => {}, setError = () => {}, name = 'file' }) => {
  const { handleError, error } = useContext(ToastContext);

  const baseStyle = {
    flex: 1,
    display: 'flex',
    height: '300px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: '#ff1744',
  };

  const displayToastErrorsForFiles = (files) => {
    for (const { errors } of files) {
      setError(true);
      error(errors[0].message);
    }
  };

  return (
    <>
      <Dropzone
        onDrop={onDrop}
        onDropRejected={displayToastErrorsForFiles}
        onError={handleError}
        maxSize={50000000} // 50 mb
        accept={{ 'text/plain': [], 'text/csv': [] }}
      >
        {({
          getRootProps,
          getInputProps,
          isDragActive,
          isFileDialogActive,
          isDragAccept,
          isDragReject,
        }) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const style = useMemo(
            () => ({
              ...baseStyle,
              ...(isDragActive || isFileDialogActive ? focusedStyle : {}),
              ...(isDragAccept ? acceptStyle : {}),
              ...(isDragReject ? rejectStyle : {}),
            }),
            [isDragActive, isFileDialogActive, isDragAccept, isDragReject]
          );
          return (
            <div {...getRootProps({ style })}>
              <input data-cy="file-input" {...getInputProps()} name={name} />
              <UploadIcon />
              <p className="mt-2">Upload Files here</p>
            </div>
          );
        }}
      </Dropzone>
    </>
  );
};
